import React, { useState } from 'react';
import { Buildings, CaretDown } from '@phosphor-icons/react';
import { useWarehouse } from '../context/WarehouseContext';

export default function WarehouseSwitcher() {
  const { warehouses, currentWarehouse, switchWarehouse } = useWarehouse();
  const [open, setOpen] = useState(false);

  if (!warehouses || warehouses.length === 0) return null;

  return (
    <div className="relative" data-testid="warehouse-switcher">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3 py-1.5 bg-secondary hover:bg-accent text-sm font-medium text-foreground border border-border rounded-md transition-colors"
      >
        <Buildings size={16} />
        <span className="font-mono">{currentWarehouse?.code || 'Select WH'}</span>
        <CaretDown size={12} weight="bold" />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-1 bg-popover border border-border shadow-lg z-20 min-w-[200px] rounded-md overflow-hidden">
            {warehouses.map(wh => (
              <button
                key={wh.id}
                onClick={() => { switchWarehouse(wh.id); setOpen(false); }}
                className={`w-full text-left px-3 py-2 hover:bg-accent flex items-center justify-between ${currentWarehouse?.id === wh.id ? 'bg-accent text-foreground font-semibold' : 'text-foreground'}`}
              >
                <div>
                  <p className="text-sm font-bold font-mono">{wh.code}</p>
                  <p className="text-xs text-muted-foreground">{wh.name}</p>
                </div>
                {wh.is_default && <span className="text-xs text-amber-600">★</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
